// Aloha Amino wordmark.
//
// The brand mark is the lowercase "aloha amino" wordmark set in Fredoka
// (rounded geometric sans) — charcoal on light surfaces, white in dark mode.
// Color + font come from the `.aa-wordmark` rule in styles/index.css, so a
// bare <Logo /> is already on-brand. To recolor on a dark/blue surface, pass
// an important text utility, e.g. className="!text-white text-xl".
//
// Props:
//   className — sizing/overrides. Size is driven by font-size, so pass a
//               text-* class (default text-2xl).
//   stacked   — render the two-line lockup ("aloha" over "amino") used for
//               large hero placements; default is the horizontal lockup.
export default function Logo({ className = 'text-2xl', stacked = false, title = 'Aloha Amino' }) {
  if (stacked) {
    return (
      <span
        role="img"
        aria-label={title}
        className={`aa-wordmark inline-flex flex-col items-start font-semibold leading-[0.82] tracking-[-0.02em] ${className}`}
      >
        <span>aloha</span>
        <span className="text-[0.66em] leading-none">amino</span>
      </span>
    );
  }
  return (
    <span
      role="img"
      aria-label={title}
      className={`aa-wordmark inline-block font-semibold tracking-[-0.02em] whitespace-nowrap ${className}`}
    >
      aloha{' '}amino
    </span>
  );
}
